module.exports = "<p>\n  adminlistados-extraescolares-crear works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlistados-extraescolares-crear/adminlistados-extraescolares-crear.component.html
// module id = ./src/app/adminlistados-extraescolares-crear/adminlistados-extraescolares-crear.component.html
// module chunks = main